import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
  userActions,
  permissionActions,
  inventoryActions,
  notificationActions,
  chatActions,
} from '../../_actions';
import { authHeader, config } from '../../_helpers';
import Modal from 'react-responsive-modal';
import NewModal from 'react-responsive-modal';
import moment from 'moment';
import { toast } from 'react-toastify';
import { AlertPopup } from '../../_components/AlertPopup';
import ReactModal from 'react-modal';
import NumberFormat from 'react-number-format';
import { UserDocsList } from '../../Resources/UserDocsList';
import { docsService } from '../../_services/docs.service';
import { getCompanyName, unAvailableReason } from '../../_utils/utils';
import ChangePassword from 'ChangePassword';
import ChangeStatusModal from '_components/ChangeStatusModal';
import ApplicationHistoryAlert from '_components/ApplicantHistoryAlert';
import EmploymentHistory from '../../Resources/EmploymentHistory';
import ViewExpiryAndAssignedDates from '_components/ViewExpiryAndAssignedDates';
import { userService } from '_services/user.service';
import { handleErrorResponse } from '_helpers/helpers';
import ViewProfile from '_components/Profile/ViewProfile';
import DatePicker from 'react-datepicker';
import { dateTimeConstants } from '_constants';

ReactModal.setAppElement('#app');

function formatPhoneNumber(s) {
  var s2 = ('' + s).replace(/\D/g, '');
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : m[1] + '-' + m[2] + '-' + m[3];
}

class ProfileComponent extends React.Component {
  constructor(props) {
    super(props);
    
    // Handle different prop structures for different contexts
    let hash, tab;
    if (props.isSettingsContext) {
      // Settings context - hash is passed directly
      hash = props.hash;
      tab = 'profile'; // Settings always shows profile tab
    } else if (props.hash && typeof props.hash === 'string' && props.hash.startsWith('/resource-profile/')) {
      // YourCrew context - hash is a full path, extract the hash part
      hash = props.hash.split('/')[2]; // Get the hash from '/resource-profile/HASH'
      tab = 'profile'; // Default tab for YourCrew
    } else if (props.hash && typeof props.hash === 'string' && !props.hash.startsWith('/')) {
      // YourCrew context - hash is passed directly as just the hash
      hash = props.hash;
      tab = 'profile'; // Default tab for YourCrew
    } else if (props.props) {
      // Resources context - hash is in props.props
      hash = props.props;
      tab = props.match?.params?.step || 'profile';
    } else {
      // Fallback
      hash = '';
      tab = 'profile';
    }
    
    this.state = {
      hash: hash,
      request_rehire_doc: false,
      request_rehire_doc_status: false,
      tab: tab,
      statusOpen: false,
      removeOpen: false,
      archiveStep: '3a',
      alertOpen: false,
      mailSendOpen: false,
      doc_request: '',
      requireDocs: false, // for status modal
      email: true,
      sms: true,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      message: '',
      notes: '',
      alertPop: false,
      userName: '',
      afterSuccess: false,
      inventoryUserAlert: false,
      isGuest: false,
      unavailableReason: 0,
      reasonToDisplay: 0,
      unavailableErr: '',
      otherReason: '',
      displayOtherReason: '',
      sendingDDForm: false,
      send_dd_form_confirm: false,
      lastDayWorked: moment(),
      lastDayReason: '',
      lastDayReasonErr: '',
      reloadKey: 0,
      loader: false,
    };
    this.goBack = this.goBack.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.handleRemoveEmployee = this.handleRemoveEmployee.bind(this);
    this.removeCloseModal = this.removeCloseModal.bind(this);
    this.alertOpenModal = this.alertOpenModal.bind(this);
    this.alertCloseModal = this.alertCloseModal.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
    this.unlockProfile = this.unlockProfile.bind(this);
    this.requireDocs = this.requireDocs.bind(this);
    this.lockProfile = this.lockProfile.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
    this.collectLastDayWorked = this.collectLastDayWorked.bind(this);
  }

  componentDidMount() {
    console.log('ProfileComponent componentDidMount - Settings context:', this.props.isSettingsContext);
    console.log('ProfileComponent componentDidMount - hash:', this.state.hash);
    var hash = '?hash=' + this.state.hash;
    this.props.dispatch(userActions.getProfile(hash));
    this.props.dispatch(permissionActions.getPermission());
    let data = new FormData();
    data.append('hash', this.state.hash);
    this.props.dispatch(inventoryActions.getInventoryList(data));
    this.props.dispatch(chatActions.getConversationSettings());
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;

    if (user?.lockProfileSuccess && !prevProps.user?.lockProfileSuccess) {
      this.statusCloseModal();
      toast.success('Profile updated successfully');
      this.setState({
        reloadKey: this.state.reloadKey + 1,
        lastDayReason: '',
        lastDayWorked: moment(),
        loader: false,
      });
    }

    if (user?.lockProfileFailure && !prevProps.user?.lockProfileFailure) {
      this.statusCloseModal();
      toast.error('Failed to update profile');
      this.setState({ loader: false });
    }

    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user, inventory, permission } = nextProps;
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
      this.setState({ permList });
    }

    var generalQualificationList = [],
      inventory_list = [];
    if (inventory.inventory) {
      if (inventory.inventory.data) {
        var total_cost = 0;
        inventory.inventory.data.map((item, index) => {
          total_cost += parseInt(item.cost, 10);
          inventory_list.push(
            <div className="inv_item" key={index}>
              <div className="inv_cell">
                {index + 1 + '. ' + item.unique_id + ' (' + item.type + ') '}
                <NumberFormat
                  className="cost"
                  value={item.cost}
                  displayType={'text'}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  thousandSeparator={true}
                  prefix={'$'}
                />
              </div>
            </div>
          );
          return inventory_list;
        });
        this.setState({ inventory_list, total_cost });
      }
    }
    if (user.items) {
      var profile = user.items.data;
      var available = profile.active === 'Available' ? true : false;
      this.setState({
        active: profile.active,
        status: profile.active,
        is_locked: profile.is_locked,
        available: available,
        notes: this?.state?.notes ? this?.state?.notes : profile.notes,
        profile,
        // Don't override hash if it's already set correctly
        hash: this.state.hash || profile.hash,
        userName: profile.first_name,
        user_type: user.items.data.user_type,
        resource_id: user.items.data.crew_identifier_id,
        isGuest: user.items.data.status === 3 ? true : false,
        reasonToDisplay: user.items.data.unavailable_reason,
        displayOtherReason: user.items.data.other_reason,
      });
      
      // Call callback for Settings context
      if (this.props.onProfileDataLoaded) {
        this.props.onProfileDataLoaded(profile);
      }
      if (profile.qualification) {
        profile.qualification.map((item, index) => {
          generalQualificationList.push(
            <p className="crew-profile-detail" key={index}>
              {item}
            </p>
          );
          return generalQualificationList;
        });
      }
    }

    this.setState({
      generalQualificationList,
      permList,
    });

    if (user.notes) {
      if (user.notes.success) {
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.notes.message,
          alertFunction: '',
        });
      }
      var hash = '?hash=' + this.state.hash;
      this.props.dispatch(userActions.getProfile(hash));
    }
  }

  // All the other methods from the original Profile component
  collectLastDayWorked() {
    this.setState({ archiveStep: '3b' });
  }

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  changeStepParam = (newStep) => {
    const { history, match } = this.props;
    
    // Handle different contexts
    if (match && match.params) {
      // Resources context - use match.params
      const { hash } = match.params;
      history.replace(`/resource-profile/${hash}/${newStep}`);
    } else {
      // YourCrew context - just update the state
      this.setState({ tab: newStep });
    }
  };

  ddFormConfirmCloseModal() {
    this.setState({ send_dd_form_confirm: false });
  }

  sendDDForm() {
    if (this.props.user.items.data.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      userService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({ statusOpen: false });
  }

  removeCloseModal() {
    this.setState({ removeOpen: false, archiveStep: '3a' });
  }

  alertOpenModal() {
    this.setState({ alertOpen: true });
  }

  alertCloseModal() {
    this.setState({ alertOpen: false, redirect: '/resources' });
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  handleRemoveEmployee(e) {
    let inventoryList = this.props.inventory.inventory.data || [];
    if (inventoryList && inventoryList.length) {
      this.setState({ inventoryUserAlert: true });
    } else {
      this.setState({ removeOpen: true });
    }
  }

  handleChange(event) {
    if (event.target.name === 'notes') {
      if (this.state.permList.includes('Employee Notes')) {
        this.setState({
          [event.target.name]: event.target.value,
          template: 'custommail',
        });
      }
      return;
    }
    this.setState({
      [event.target.name]: event.target.value,
      template: 'custommail',
    });
  }

  closeAlert() {
    this.setState({ alertPop: false });
  }

  changeTab(tab) {
    this.changeStepParam(tab);
    this.setState({ tab }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    docsService.requestToFillDocs(hash, doc_request).then(
      (res) => {
        this.setState({
          request_rehire_doc_status: res.success,
          request_rehire_doc: true,
        });
        var hash = '?hash=' + this.state.hash;
        this.props.dispatch(userActions.getProfile(hash));
      },
      (err) => console.log(err)
    );
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  downloadAllDocuments(event, rehire = false) {
    let { hash } = this.state.profile;
    let params = {
      uid: this.props.user.profile.data.hash,
      signature: this.props.chat.settings.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/${hash}?rehire=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
    window.open(url.href);
  }

  downloadAllDocumentsAsPDF(event, rehire = false) {
    let { hash } = this.state.profile;
    let params = {
      uid: this.props.user.profile.data.hash,
      signature: this.props.chat.settings.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?rehire=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
    window.open(url.href);
  }

  changeLastDayReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      lastDayReasonErr: '',
    });
  };

  handleLastDayChange(date) {
    if (date) {
      this.setState({ lastDayWorked: date });
    }
  }

  setStatusReturn(status) {
    if (status) {
      var step = '2a';
    } else step = '2b';
    this.setState(
      { statusStep: step },
      function () {
        this.componentWillReceiveProps(this.props);
      }
    );
  }

  setUnAvailableReason = (reason, other) => {
    return unAvailableReason(reason, other);
  };

  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  updateNotes(hash) {
    let data = new FormData();
    data.append('hash', hash);
    data.append('note', this.state.notes);
    if (this.state.notes !== null) {
      this.setState({ savingNote: true });
      this.props
        .dispatch(userActions.updateEmployeeNote(data, '?hash=' + hash))
        .then(
          (res) => {
            toast.success('Notes Saved !');
            this.setState({ savingNote: false });
          },
          (err) => {
            toast.error('Notes Cannot be saved');
            this.setState({ savingNote: false });
          }
        );
    }
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status) {
    if (status) {
      var stat =
        this.state.status === 'Available' ? 'Unavailable' : 'Available';
      var hash = '?hash=' + this.state.hash;
      let data = new FormData();
      this.statusCloseModal();
      data.append('end_date', this.state.returnDate);
      data.append('hash', this.state.hash);
      data.append('status', stat);
      this.props.dispatch(userActions.changeStatus(data, hash));
      this.props.dispatch(notificationActions.getCount());
      this.setState({ status: stat });
    }
  }

  lockProfile() {
    if (!this.state.lastDayReason.trim()) {
      this.setState({ lastDayReasonErr: 'error' });
      return;
    }
    var stat = 'Locked';
    var hash = '?hash=' + this.state.hash;
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append('modify_active_status', true);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(dateTimeConstants.ISO_DATE_FORMAT)
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  requireDocs(e) {
    this.setState({ requireDocs: e.target.checked });
  }

  unlockProfile() {
    var stat = 'Unlocked';
    var hash = '?hash=' + this.state.hash;
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append('document', this.state.requireDocs);
    data.append('modify_active_status', true);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  remove() {
    if (!this.state.lastDayReason.trim()) {
      this.setState({ lastDayReasonErr: 'error' });
      return;
    }
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(dateTimeConstants.ISO_DATE_FORMAT)
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.removeEmployee(data)).then(
      (res) => {
        this.setState({
          alertHead: 'Success',
          alertMsg: 'Employee removed successfully.',
          removeOpen: false,
          alertOpen: true,
          archiveStep: '3a',
        });
      },
      (err) => {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg:
            'Failed to remove employee ' +
            (typeof err?.message === 'string' ? err.message : ''),
          alertFunction: '',
          removeOpen: false,
          archiveStep: '3a',
        });
      }
    );
  }

  goBack() {
    this.props.goBack(this.props.resourceDetails);
  }

  toResourceList() {
    this.props.toResourceList();
  }

  editProfile(hash) {
    this.props.editProfile(hash);
  }

  print() {
    window.print();
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    var self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  render() {
    const { permission } = this.props;
    let user;
    this.props &&
      this.props.user &&
      this.props.user.items &&
      (user = this.props.user.items.data);

    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    if (this.state.redirect === '/resources') {
      return <Redirect to={'/resources/' + this.state.resource_id} />;
    }

    // For Settings context, render the profile content with action buttons but without breadcrumbs
    if (this.props.isSettingsContext) {
      if (this.state.profile) {
        return (
          <div className="content_div settings">
            <div className="clearFix" />
            <ViewProfile
              userHash={this.props?.user?.items?.data?.hash}
              authUser={this.props?.user?.profile?.data?.hash}
              permList={permList}
              changeTab={this.changeTab}
              reloadKey={this.state.reloadKey}
            />
          </div>
        );
      } else {
        return (
          <center
            id="feedLoader"
            className={this.state.loader ? this.state.loader : ''}
          >
            <img
              alt="Loader"
              src={require('../../assets/images/loader.gif').default}
            />
          </center>
        );
      }
    }

    if (this.state.profile) {
      return (
        <div className="resource_container profile_container">
          <div className="breadcrumbs">
            <Link
              onClick={this.toResourceList.bind(this)}
              to={'/resources'}
              className="green"
            >
              Resources
            </Link>{' '}
            / <Link to={'/resources/' + this.state.resource_id}>Details</Link> /
            Profile
          </div>
          <div className="page_title float">
            <h1>
              {this.state.profile
                ? this.state.profile.first_name +
                  ' ' +
                  this.state.profile.last_name
                : ''}
            </h1>
            <div className="btn_list">
              {this.state.tab == 'profile' ? (
                <React.Fragment>
                  {permList.includes('Manage Passwords') && (
                    <ChangePassword
                      userType="user"
                      user={this.state.profile}
                      isAdmin={
                        this.props?.user?.profile?.data?.is_admin !== 0
                          ? true
                          : false
                      }
                      className={'edit_resource'}
                    />
                  )}
                  <button
                    className="button print"
                    onClick={this.print.bind(this)}
                  >
                    Print
                  </button>
                  {permList.includes('Message Employees') && (
                    <button
                      className="button edit_resource"
                      onClick={this.mailSendOpenModal.bind(this)}
                    >
                      Message
                    </button>
                  )}
                  {permList.includes('Status Update') && (
                    <button
                      className="button edit_resource"
                      onClick={this.statusOpenModal.bind(this)}
                    >
                      Edit Status
                    </button>
                  )}

                  {permList.includes('Remove Employee') && (
                    <button
                      className="button edit_resource"
                      onClick={this.handleRemoveEmployee.bind(this)}
                    >
                      Remove Employee
                    </button>
                  )}
                  {permList.includes('Send DD Form') && (
                    <button
                      className="button edit_resource"
                      onClick={this.openDdformConfirmModal.bind(this)}
                      disabled={this.state.sendingDDForm}
                    >
                      Send DD Form
                    </button>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {permList.includes('Manage Docs') &&
                    user.docs_status === -1 && (
                      <button
                        className={`button edit_resource ${user && user.rehire_docs_status !== -1 && 'disabled'}`}
                        onClick={() =>
                          this.documentRequest(user.hash, 'onboarding')
                        }
                        disabled={user && user.docs_status !== -1}
                      >
                        {user && user.docs_status === -1
                          ? 'Ask to Fill Onboarding Documents'
                          : 'Asked to Fill Onboarding Documents'}
                      </button>
                    )}
                  {permList.includes('Manage Docs') &&
                    user.rehire_docs_status === -1 &&
                    user.docs_status >= 2 && (
                      <button
                        className={`button edit_resource ${user && user.rehire_docs_status !== -1 && 'disabled'}`}
                        onClick={() =>
                          this.documentRequest(user.hash, 'rehire')
                        }
                        disabled={user && user.rehire_docs_status !== -1}
                      >
                        {user && user.rehire_docs_status === -1
                          ? 'Ask to Fill Rehire Documents'
                          : 'Asked to Fill Rehire Documents'}
                      </button>
                    )}
                  {permList.includes('Manage Docs') &&
                    user.docs_status >= 2 && (
                      <button
                        className="button edit_resource"
                        onClick={this.downloadAllDocuments}
                        title="Download Onboarding documents as ZIP File"
                      >
                        Onboarding{' '}
                        <i className="fas fa-file-archive text-white inline-icons"></i>
                      </button>
                    )}
                  {permList.includes('Manage Docs') &&
                    user.docs_status >= 2 && (
                      <button
                        className="button primary edit_resource"
                        onClick={this.downloadAllDocumentsAsPDF}
                        title="Download Onboarding documents as PDF"
                      >
                        Onboarding{' '}
                        <i className="fas fa-file-pdf text-white inline-icons"></i>
                      </button>
                    )}
                  {permList.includes('Manage Docs') &&
                    user.rehire_docs_status >= 2 && (
                      <button
                        className="button edit_resource"
                        onClick={(event) =>
                          this.downloadAllDocuments(event, true)
                        }
                        title="Download Rehire documents as ZIP File"
                      >
                        Rehire{' '}
                        <i className="fas fa-file-archive text-white inline-icons"></i>
                      </button>
                    )}
                  {permList.includes('Manage Docs') &&
                    user.rehire_docs_status >= 2 && (
                      <button
                        className="button primary edit_resource"
                        onClick={(event) =>
                          this.downloadAllDocumentsAsPDF(event, true)
                        }
                        title="Download Rehire documents as PDF"
                      >
                        Rehire{' '}
                        <i className="fas fa-file-pdf text-white inline-icons"></i>
                      </button>
                    )}
                  <ReactModal
                    isOpen={this.state.request_rehire_doc}
                    onClose={this.docRequestModalClose.bind(this)}
                    contentLabel="Rehire Request"
                    overlayClassName="alertPopup"
                  >
                    <div id="rehire_request" className="popupModal">
                      <div className="modal-head">
                        <h4 className="modal-title">
                          Request {this.state.doc_request} Docs
                        </h4>
                      </div>
                      <div className="modal-body">
                        {this.state.request_rehire_doc_status ? (
                          <p>
                            Request for fill out{' '}
                            <span className="modal-word-highlight">
                              {this.state.doc_request.toUpperCase()} documents
                            </span>
                            ,sent out to the user.
                          </p>
                        ) : (
                          <p>
                            Unable to request{' '}
                            <strong>
                              {this.state.doc_request.toUpperCase()} documents
                            </strong>
                            !!!
                          </p>
                        )}
                        <div className="btn_list">
                          <button
                            className="button"
                            onClick={this.docRequestModalClose.bind(this)}
                          >
                            Ok
                          </button>
                        </div>
                      </div>
                    </div>
                  </ReactModal>
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="applicants_inner_head inner_head header_tabs">
            <h2
              className={this.state.tab === 'profile' ? 'active' : ''}
              onClick={this.changeTab.bind(this, 'profile')}
            >
              Profile
            </h2>
            {permList.includes('Manage Docs') && (
              <h2
                className={this.state.tab === 'docs-list' ? 'active' : ''}
                onClick={this.changeTab.bind(this, 'docs-list')}
              >
                Documents
              </h2>
            )}
            {permList.includes('Manage Employment History') && (
              <h2
                className={
                  this.state.tab === 'employment-history' ? 'active' : ''
                }
                onClick={this.changeTab.bind(this, 'employment-history')}
              >
                Application History
              </h2>
            )}
          </div>
          <div className="content_div settings">
            <div className="clearFix" />
            {(() => {
              switch (this.state.tab) {
                case 'profile':
                  return (
                    <ViewProfile
                      userHash={this.props?.user?.items?.data?.hash}
                      authUser={this.props?.user?.profile?.data?.hash}
                      permList={permList}
                      changeTab={this.changeTab}
                      reloadKey={this.state.reloadKey}
                    />
                  );
                case 'docs-list':
                  return (
                    <UserDocsList
                      userHash={this.props?.user?.items?.data?.hash}
                    />
                  );
                case 'employment-history':
                  return (
                    <EmploymentHistory
                      hash={this.props?.user?.items?.data?.hash}
                    />
                  );
                default:
              }
            })()}
          </div>
          {this.state.statusOpen ? (
            <ChangeStatusModal
              lockProfile
              open={this.state.statusOpen}
              onClose={this.statusCloseModal}
            />
          ) : null}
          <ReactModal
            isOpen={this.state.alertOpen}
            onClose={this.alertCloseModal.bind(this)}
            contentLabel="Minimal Modal Example"
            overlayClassName="alertPopup"
          >
            <div id="statusPopup" className="popupModal">
              <div className="modal-head">
                <h4 className="modal-title">{this.state.alertHead}</h4>
              </div>
              <div className="modal-body">
                <p>{this.state.alertMsg}</p>
                <div className="btn_list">
                  <button
                    className="button"
                    onClick={this.alertCloseModal.bind(this)}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </ReactModal>
          <Modal
            id="remove_popup"
            className="status_popup"
            open={this.state.send_dd_form_confirm}
            onClose={this.ddFormConfirmCloseModal.bind(this)}
            little
          >
            <div id="removePopup">
              <div className="modal-head">
                <h4 className="modal-title">Direct Deposit Form</h4>
              </div>
              <div className="modal-body">
                <label>
                  This will send an email to{' '}
                  {this.state.profile
                    ? this.state.profile.first_name +
                      ' ' +
                      this.state.profile.last_name
                    : 'this employee'}
                  , with Direct Deposit form link.
                </label>
                <br />
                <button
                  className="button grey"
                  onClick={this.ddFormConfirmCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button className="button" onClick={this.sendDDForm.bind(this)}>
                  Send
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            id="remove_popup"
            className="status_popup"
            open={this.state.inventoryUserAlert}
            onClose={() => {
              this.setState({ inventoryUserAlert: false });
            }}
            little
          >
            <div id="removePopup">
              <div className="modal-head">
                <h4 className="modal-title">Error: Remove Inventory First</h4>
              </div>
              <div className="modal-body">
                <label>
                  In order to remove this employee you need to remove their
                  inventory first
                </label>
                <br />
                <Link to="/inventory">
                  <button className="button">Go to inventory</button>
                </Link>
                <button
                  className="button grey"
                  onClick={() => {
                    this.setState({ inventoryUserAlert: false });
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
          <NewModal
            id="remove_popup"
            className="status_popup"
            open={this.state.removeOpen}
            onClose={this.removeCloseModal.bind(this)}
            little
          >
            <div id="removePopup">
              <div className="modal-head">
                <h4 className="modal-title">
                  Remove Employee:{' '}
                  {this.state.profile
                    ? this.state.profile.first_name +
                      ' ' +
                      this.state.profile.last_name
                    : ''}
                </h4>
              </div>
              <div className="modal-body">
                {this.state.archiveStep == '3a' && (
                  <div>
                    <label>
                      Are you sure you want to archive this employee?
                    </label>
                    <br />
                    <button
                      className="button grey"
                      onClick={this.removeCloseModal.bind(this)}
                    >
                      Cancel
                    </button>
                    <button
                      className="button"
                      onClick={this.collectLastDayWorked.bind(this)}
                    >
                      Archive
                    </button>
                  </div>
                )}
                {this.state.archiveStep == '3b' && (
                  <div className="status_step step1">
                    <section
                      className="d-flex flex-column checkb"
                      style={{ padding: '10px' }}
                    >
                      <div classNames="full-width">
                        <p>Last Day Worked</p>
                        <DatePicker
                          className="lastDayWorked"
                          name="lastDayWorked"
                          selected={this.state.lastDayWorked}
                          onChange={this.handleLastDayChange.bind(this)}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                        <textarea
                          rows="3"
                          maxLength={1200}
                          className="lastDayReason"
                          value={this.state.lastDayReason}
                          name="lastDayReason"
                          onChange={this.changeLastDayReason}
                          errors={this.state.lastDayReasonErr}
                        />
                      </div>
                    </section>
                    <div className="user-status-edit-wrapper">
                      <div>
                        <button
                          disabled={this.state.loader}
                          className="button grey"
                          onClick={this.removeCloseModal.bind(this)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className="button"
                          onClick={this.remove.bind(this)}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </NewModal>
          <Modal
            id="email_popup"
            className="status_popup"
            open={this.state.mailSendOpen}
            onClose={this.mailSendCloseModal.bind(this)}
            little
          >
            <div id="emailPopup">
              <div className="modal-head">
                <h4 className="modal-title">Custom Message</h4>
              </div>
              <div className="modal-body">
                <textarea
                  name="message"
                  cols="80"
                  rows="10"
                  value={this.state.message}
                  onChange={this.handleChange.bind(this)}
                />
                <p className="step_no">
                  Signature will automatically be included.
                </p>
                <button
                  className="button grey"
                  onClick={this.mailSendCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className="button"
                  onClick={this.sendMail.bind(this, this.state.hash)}
                >
                  Send
                </button>
              </div>
            </div>
          </Modal>
          {this.state.alertPop && (
            <AlertPopup
              head={this.state.alertHead}
              message={this.state.alertMsg}
              alertFunction={this.state.alertFunction}
              close={this.closeAlert.bind(this)}
            />
          )}
        </div>
      );
    }
    return (
      <div className="resource_container profile_container">
        <div className="page_title float">
          <h1>
            {this.state.profile
              ? this.state.profile.first_name +
                ' ' +
                this.state.profile.last_name
              : ''}
          </h1>
          <div className="btn_list">
            {permList.includes('Manage Passwords') && (
              <ChangePassword
                userType="user"
                user={this.state.profile}
                isAdmin={
                  this.props?.user?.profile?.data?.is_admin !== 0 ? true : false
                }
                className={'edit_resource'}
              />
            )}
            <button className="button print" onClick={this.print.bind(this)}>
              Print
            </button>
            {permList.includes('Message Employees') && (
              <button
                className="button edit_resource"
                onClick={this.mailSendOpenModal.bind(this)}
              >
                Message
              </button>
            )}
                              {permList.includes('Status Update') && (
                    <button
                      className="button edit_resource"
                      onClick={this.statusOpenModal.bind(this)}
                    >
                      Edit Status
                    </button>
                  )}
                  {permList.includes('Remove Employee') && (
              <button
                className="button edit_resource"
                onClick={this.handleRemoveEmployee.bind(this)}
              >
                Remove Employee
              </button>
            )}
          </div>
        </div>
        <div className="applicants_inner_head inner_head" />
        <div className="content_div settings">
          <center
            id="feedLoader"
            className={this.state.loader ? this.state.loader : ''}
          >
            <img
              alt="Loader"
              src={require('../../assets/images/loader.gif').default}
            />
          </center>
        </div>
      </div>
    );
  }
}

export default ProfileComponent; 